import { createFileRoute } from '@tanstack/react-router';
import { LEGAL } from '~/lib/legal';
import { buildHead } from '~/seo/site';
import { CookiesDoc, LegalNoticeDoc, PrivacyDoc, TermsDoc } from '~/ui/legal-docs';

export const Route = createFileRoute('/legal')({
  head: () =>
    buildHead({
      title: 'Legal',
      description:
        'Prod Battle legal hub: Legal Notice, Terms of Service, Privacy Policy (GDPR), and Cookie Policy, all in one place.',
      path: '/legal',
    }),
  component: Legal,
});

const TOC = [
  { id: 'notice', label: 'Legal Notice' },
  { id: 'terms', label: 'Terms of Service' },
  { id: 'privacy', label: 'Privacy Policy' },
  { id: 'cookies', label: 'Cookie Policy' },
];

function Legal() {
  return (
    <article className="mx-auto max-w-3xl px-4 py-12 space-y-8">
      <header className="space-y-2">
        <h1 className="text-3xl font-bold tracking-tight">Legal</h1>
        <p className="text-xs uppercase tracking-wider text-muted-foreground">
          Last updated: {LEGAL.effectiveDate}
        </p>
        <p className="pt-2 text-sm text-muted-foreground leading-relaxed">
          Everything in one place: who runs {LEGAL.brand}, the terms you agree to, how we handle
          your data, and the cookies we use.
        </p>
        <nav className="flex flex-wrap gap-2 pt-2 text-xs">
          {TOC.map((t) => (
            <a
              key={t.id}
              href={`#${t.id}`}
              className="rounded-full border border-border px-3 py-1 text-muted-foreground hover:border-primary hover:text-foreground"
            >
              {t.label}
            </a>
          ))}
        </nav>
      </header>

      <LegalNoticeDoc />
      <TermsDoc />
      <PrivacyDoc />
      <CookiesDoc />
    </article>
  );
}
